import { useDataChange, useDataValue } from 'Simple/Data.js'

export function useOnDelete(props) {
  let index = useDataValue({
    context: 'retail_item_item',
    path: 'index',
    viewPath: props.viewPath,
  })
  let change = useDataChange({
    context: 'create_invoice',
    viewPath: props.viewPath,
  })

  return function onDelete() {
    change(next => {
      next.retail_items.splice(index, 1)
    })
  }
}
